import { Text } from '@backyard-ui/core';

import { generatePageRange } from './utils';

interface PageIndicatorProps {
  currentPage: number;
  pageSize: number;
  totalReviewsCount: number;
}

function PageIndicator(props: Readonly<PageIndicatorProps>) {
  const { totalReviewsCount } = props;

  return (
    <Text asChild>
      <span>
        {`${generatePageRange(props)} de ${totalReviewsCount} avaliações`}
      </span>
    </Text>
  );
}

export default PageIndicator;
